export interface EntitySummary {
	Id: string;
	Name: string;
}

/**
 * Accepts the real Supabase client or a test mock. The builder chain is left
 * untyped: checking PostgREST's builder generics against a structural type
 * exceeds TypeScript's instantiation depth (TS2589).
 */
interface EntityQueryClient {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	from(table: string): any;
}

/**
 * Loads the current user's rows from an entity table for the submit wizard
 * dropdown. Entity tables disagree on their display-name column (location
 * tables and Characters use "Name"; Campaigns, Stories, etc. use "Title"),
 * and PostgREST rejects the whole query if a selected column is missing on
 * the table — so select everything and resolve the name client-side, the
 * same way the competition-snapshot edge function does.
 */
export async function fetchEntitySummaries(
	client: EntityQueryClient,
	table: string,
	userId: string,
): Promise<EntitySummary[]> {
	const { data, error } = (await client
		.from(table)
		.select('*')
		.eq('Creator', userId)
		.limit(100)) as {
		data: Record<string, unknown>[] | null;
		error: { message: string } | null;
	};
	if (error) throw new Error(error.message);
	return (data ?? []).map((row) => ({
		Id: row.Id as string,
		Name: (row.Name ?? row.Title ?? 'Untitled') as string,
	}));
}
